import React from 'react';
import '../../css/FAQ.css';

function FAQ() {
    return (
        <div className="faq-container">
            <h1>Frequently Asked Questions (FAQ)</h1>

            <h2>1. What is Mentium.pro?</h2>
            <p>Mentium.pro is a Relationship Marketplace designed to make real estate transactions easier for Realtors. We connect Realtors with exceptional Service Companies through a curated B2B marketplace.</p>

            <h2>2. How is Mentium.pro different from other marketplaces?</h2>
            <p>Unlike other platforms, we don’t sell leads. Instead, we focus on facilitating mutually beneficial relationships between Realtors and Service Companies to help both parties thrive.</p>

            <h2>3. Who can join Mentium.pro?</h2>
            <p>Our platform is tailored for Realtors and Service Companies who want to connect and collaborate for real estate-related services.</p>

            <h2>4. What types of services can be found on Mentium.pro?</h2>
            <p>Mentium.pro features various service providers, including contractors, home inspectors, staging professionals, and other real estate-related businesses.</p>

            <h2>5. Is Mentium.pro free to use?</h2>
            <p>Realtors and Service Companies can sign up and browse the platform for free. Premium features or enhanced visibility options may be available at additional costs.</p>

            <h2>6. How does Mentium.pro ensure the quality of Service Companies?</h2>
            <p>We curate our marketplace carefully by personally verifying every Service Company to maintain a high-quality standard.</p>

            <h2>7. How can I sign up for Mentium.pro?</h2>
            <p>Visit our website at <a href="http://www.mentium.pro">www.mentium.pro</a>, click “Join Us Now," and follow the registration process tailored for Realtors or Service Companies.</p>

            <h2>8. Does Mentium.pro provide leads?</h2>
            <p>No, we don’t sell leads. Our platform is designed to build relationships and foster collaboration, not just provide contact lists.</p>

            <h2>9. How does Mentium.pro handle privacy and data protection?</h2>
            <p>We prioritize your privacy. Our Privacy Notice explains how we collect, process, and protect your personal information.</p>

            <h2>10. How can I contact Mentium.pro for support?</h2>
            <p>If you have questions or need assistance, contact us at <a href="mailto:info@mentium.pro">info@mentium.pro</a>.</p>
        </div>
    );
}

export default FAQ;
